import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '#web-components/components/Typography';
import Divider from '#web-components/components/Divider';

import styles from './LoginSidebar.styles';

const useStyles = makeStyles(styles, { name: 'LoginSidebar' });

function LoginSidebar() {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div>
      <Typography variant="h6" className={classes.text}>
        {t('sidebar.title')}
      </Typography>
      <Typography variant="textSmall" className={classes.text}>
        {t('sidebar.ecpDescription')}
      </Typography>
      <Typography variant="textSmall" className={classes.text}>
        {t('sidebar.checkDescription')}
      </Typography>
      <Divider className={classes.divider} />
      <Typography variant="textSmall" className={classes.text}>
        {t('sidebar.usageWarning')}
      </Typography>
      <Typography variant="textSmall" className={classes.text}>
        {t('sidebar.diiaSignUsageWarning')}
      </Typography>
    </div>
  );
}

export default LoginSidebar;
